import { render, staticRenderFns } from "./AuctionDetailsTabsNew.vue?vue&type=template&id=7b3c8f55&scoped=true"
import script from "./AuctionDetailsTabsNew.vue?vue&type=script&lang=js"
export * from "./AuctionDetailsTabsNew.vue?vue&type=script&lang=js"
import style0 from "./AuctionDetailsTabsNew.vue?vue&type=style&index=0&id=7b3c8f55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3c8f55",
  null
  
)

export default component.exports